export default {
  'reportGroups.form.powerBIServerConfigurationId': 'Configuración Servidor Power BI',
  'reportGroups.form.powerBIReportGroupId': 'Id Grupo de PowerBI',
  'reportGroups.permissions.description':
    'Agregue o retire quién puede acceder al grupo de reportes {name}.',
  'reportGroups.form.owner': 'Propietario',
};
